import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import './ForgotPasswordForm.css'
import CButton from '../../../components/UI/CButton'
import CTextField from '../../../components/UI/CTextField'

/**
 * Forgot password form component (username entry step)
 */
const ForgotPasswordForm = ({ onSubmit, onBackToLogin }) => {
    const { isLoading } = useSelector((state) => state.auth)

    const [username, setUsername] = useState('')
    const [usernameError, setUsernameError] = useState('')

    const handleChange = (e) => {
        setUsername(e.target.value)
        if (usernameError) {
            setUsernameError('')
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!username) {
            setUsernameError('Username is required')
            return
        }

        if (onSubmit) {
            onSubmit(username.trim())
        }
    }

    const handleBackClick = (e) => {
        e.preventDefault()
        if (onBackToLogin) {
            onBackToLogin()
        }
    }

    return (
        <>
            <div className="form-header">
                <h2 className="form-title header-2">Forgot password?</h2>
                <p className="form-subtitle text-4">
                    No worries! Enter your username below and we'll send you a verification code to reset your password.
                </p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-fields">
                    <CTextField
                        fullWidth
                        label="Username"
                        name="username"
                        type="text"
                        leftIcon="single-neutral-id-card"
                        value={username}
                        onChange={handleChange}
                        error={!!usernameError}
                        helperText={usernameError}
                        disabled={isLoading}
                        autoComplete="username"
                        autoFocus
                    />
                </div>

                <div className="divider"></div>

                <CButton
                    className="submit-button"
                    type="submit"
                    variant="contained"
                    size="large"
                    fullWidth
                    showLoader={isLoading}
                    colorTheme="primary"
                    label="Continue"
                    disabled={isLoading || !username}
                />

                {onBackToLogin && (
                    <CButton
                        className="back-link"
                        type="button"
                        variant="text"
                        size="large"
                        fullWidth
                        onClick={handleBackClick}
                        disabled={isLoading}
                        colorTheme="secondary"
                        label="Back to Login"
                    />
                )}
            </form>
        </>
    )
}

ForgotPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onBackToLogin: PropTypes.func,
}

export default ForgotPasswordForm
